<template>
  <div qaid="virtual-packing-slip-order-grid" class="my-6">
    <div v-for="order in allPackingOrders" :key="order[0].orderNumber">
      <div v-if="Array.isArray(order) && order.length" class="flex flex-col md:flex-row justify-between">
        <p>
          <span qaid="packing-slip-order-number" class="font-medium">
            {{ $t('text.account.packingslip.ordernumber') }}:
          </span>
          <trek-link id="shipment-tracking-number" underline :href="order[0].orderUrl">
            <span v-html="order[0].orderNumber" />
          </trek-link>
        </p>
        <p>
          <span qaid="packing-slip-order-grid-invoice" class="font-medium"> {{ $t('text.invoiceNumber') }}: </span>
          <trek-button
            id="shipment-invoice-number"
            text
            underline
            @click="downloadInvoice(order[0].invoiceDocumentType, order[0].invoiceNumber)"
          >
            <span v-html="order[0].invoiceNumber" />
          </trek-button>
        </p>
      </div>
      <table class="b2b-grid b2b-grid--collapse is-compact table-fixed" qaid="packing-slip-order-grid">
        <thead class="b2b-grid__header">
          <tr>
            <th
              v-for="(item, index) in colHeaders"
              :key="index"
              :qaid="`virtual-packing-slip-order-grid-header-${item}`"
              :class="['b2b-grid__cell', 'b2b-grid__head', {'lg:w-1/2': item === 'description'}]"
            >
              <span>{{ $t(item) }}</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="data in order" :key="data.id">
            <td qaid="packing-order-grid-sku" class="b2b-grid__cell lg:table-cell">
              <div class="b2b-grid__label">{{ $t('text.itemNumber') }}</div>
              <div class="b2b-grid__content">
                <trek-link
                  v-if="data.productType !== 'Project One Bikes'"
                  id="item-sku-pdp-url"
                  underline
                  :href="data.pdpUrl"
                >
                  <grid-text
                    :data="{
                      value: data.itemSku,
                    }"
                  />
                </trek-link>
                <grid-text
                  v-else
                  :data="{
                    value: data.itemSku,
                  }"
                />
              </div>
            </td>

            <td qaid="packing-order-grid-quantity" class="b2b-grid__cell lg:table-cell">
              <div class="b2b-grid__label">{{ $t('text.quantity') }}</div>
              <div class="b2b-grid__content">
                <grid-text
                  :data="{
                    value: data.quantityAllocatedOrShipped,
                  }"
                />
              </div>
            </td>

            <td qaid="packing-order-grid-description" class="b2b-grid__cell lg:table-cell">
              <div class="b2b-grid__label">{{ $t('distributor.B2B.advancedOrder.name') }}</div>
              <div v-if="data.itemDescription" class="b2b-grid__content">
                <grid-text
                  :data="{
                    value: data.itemDescription,
                  }"
                />
              </div>
            </td>

            <td qaid="packing-order-grid-unit-price" class="b2b-grid__cell lg:table-cell">
              <div class="b2b-grid__label">{{ $t('text.unitPrice') }}</div>
              <div class="b2b-grid__content">
                <grid-text
                  :data="{
                    value: data.unitPrice,
                  }"
                />
              </div>
            </td>

            <td qaid="packing-order-grid-sku-extended-price" class="b2b-grid__cell lg:table-cell">
              <div class="b2b-grid__label">{{ $t('text.extendedPrice') }}</div>
              <div class="b2b-grid__content">
                <grid-text
                  :data="{
                    value: data.extendedPrice,
                  }"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pdl-callout v-if="Object.keys(allPackingOrders).length === 0" kind="default">
      <template #content>
        <span>{{ $t('assistedService.B2B.saved.noItems') }}</span>
      </template>
    </pdl-callout>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import GridText from '@/components/grid/GridText';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {GridText, PdlCallout},

  props: {
    size: {
      type: Number,
      default: 50,
    },
    packingOrders: {
      type: Array,
      required: true,
    },
    billToNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      colHeaders: [
        'text.itemNumber',
        'text.quantity',
        'distributor.B2B.advancedOrder.name',
        'text.unitPrice',
        'text.extendedPrice',
      ],
      allOrders: [...this.packingOrders],
    };
  },
  computed: {
    ...mapState('preSeason', ['orderReview']),
    ...mapState('backend', ['encodedContextPath']),

    allPackingOrders() {
      const orders = this.allOrders;
      orders.forEach((items) => {
        items.map((val) => {
          val.orderUrl = `${this.encodedContextPath}${val.orderUrl}`;
          val.pdpUrl = `${this.encodedContextPath}/p/${val.itemSku}`;
        });
      });
      return orders;
    },
  },
  methods: {
    isHeaderAlignRight(item) {
      return item === 'subtotal';
    },
    downloadInvoice(documentType, invoiceNumber) {
      window.location.href = `/my-account/invoices/${invoiceNumber}_${documentType}/${this.billToNumber}/`;
    },
  },
};
</script>
